import { Capacitor } from "@capacitor/core";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";

/** Runtime override also repairs already-installed hosted iOS shells. */
export async function configureKeyboardViewport() {
  if (Capacitor.getPlatform() !== "ios") return;
  await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
}
